module.exports = __webpack_public_path__ + "img/ctf-image.2cdfa878.png";